import type { FC } from 'react';
import { PapiUser } from '@wix/da-papi-types';
import cn from 'classnames';
import { BadgesByCategoryType } from '../../../../../types/badge';
import BadgeCategory from './BadgeCategory';

import s from './BadgesByCategory.scss';

export interface Props {
  badgeCategories: BadgesByCategoryType;
  className?: string;
  widthBreakpoints?: number[];
  profileOwnerUser: PapiUser;
}

const BadgesByCategory: FC<Props> = ({
  badgeCategories,
  className,
  widthBreakpoints,
  profileOwnerUser,
}) => {
  return (
    <div className={cn(s['root'], className)}>
      {badgeCategories.achievements && badgeCategories.achievements.length && (
        <BadgeCategory
          category="achievements"
          badges={badgeCategories.achievements}
          profileOwnerUser={profileOwnerUser}
          widthBreakpoints={widthBreakpoints}
        />
      )}
      {badgeCategories.challenge && badgeCategories.challenge.length && (
        <BadgeCategory
          category="challenge"
          badges={badgeCategories.challenge}
          profileOwnerUser={profileOwnerUser}
          widthBreakpoints={widthBreakpoints}
        />
      )}
      {badgeCategories.seasonal && badgeCategories.seasonal.length && (
        <BadgeCategory
          category="seasonal"
          badges={badgeCategories.seasonal}
          profileOwnerUser={profileOwnerUser}
          widthBreakpoints={widthBreakpoints}
        />
      )}
      {badgeCategories.hidden && badgeCategories.hidden.length && (
        <BadgeCategory
          category="hidden"
          badges={badgeCategories.hidden}
          profileOwnerUser={profileOwnerUser}
          widthBreakpoints={widthBreakpoints}
        />
      )}
      {badgeCategories.milestones && badgeCategories.milestones.length && (
        <BadgeCategory
          category="milestones"
          badges={badgeCategories.milestones}
          profileOwnerUser={profileOwnerUser}
          widthBreakpoints={widthBreakpoints}
        />
      )}
    </div>
  );
};
BadgesByCategory.displayName = 'BadgesByCategory';

export default BadgesByCategory;
